import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { LanguageService, ToastComponent } from './core';
import { CookieBannerService } from './services';


@Component({
	selector: 'app-root',
	imports: [
		RouterOutlet,
		ToastComponent
	],
	templateUrl: './app.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class AppComponent implements OnInit {

	private readonly titleSrv = inject(Title);
	private readonly langSrv = inject(LanguageService);
	private readonly cookieBannerSrv = inject(CookieBannerService);

	ngOnInit(): void {
		this.titleSrv.setTitle(this.langSrv.labels().APP_MAIN_TITLE);
		this.cookieBannerSrv.openBanner();
	}
}
